const embedUrls = [
  {
    regex: /https:\/\/www\.youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]+).*/,
    embedUrl: 'https://www.youtube.com/embed/$1',
  },
  {
    regex: /https:\/\/vimeo\.com\/([0-9]+)/,
    embedUrl: 'https://player.vimeo.com/video/$1',
  },
  {
    regex: /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/,
    embedUrl: 'https://drive.google.com/file/d/$1/preview',
  },
  {
    regex: /https:\/\/www\.google\.com\/maps\/place\/([^/]+)/,
    embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d$1',
  },
  {
    regex: /https:\/\/www\.slideshare\.net\/[^/]+\/([^/]+)/,
    embedUrl: 'https://www.slideshare.net/slideshow/embed_code/key/$1',
  },
  {
    regex: /https:\/\/twitter\.com\/[^/]+\/status\/([0-9]+)/,
    embedUrl: 'https://twitframe.com/show?url=https://twitter.com/$1',
  },
  {
    regex: /https:\/\/www\.instagram\.com\/p\/([^/]+)/,
    embedUrl: 'https://www.instagram.com/p/$1/embed',
  },
  {
    regex: /https:\/\/open\.spotify\.com\/track\/([a-zA-Z0-9]+)/,
    embedUrl: 'https://open.spotify.com/embed/track/$1',
  },
  {
    regex: /https:\/\/open\.spotify\.com(\/intl-[a-zA-Z-]+)?\/(track|playlist|album|show|episode)\/([a-zA-Z0-9]+)(\?.*)?/,
    embedUrl: 'https://open.spotify.com/embed/$2/$3',
  },
  {
    regex: /https:\/\/soundcloud\.com\/[^/]+\/([^/]+)/,
    embedUrl: 'https://w.soundcloud.com/player/?url=https://soundcloud.com/$1',
  },
  {
    regex: /https:\/\/www\.facebook\.com\/[^/]+\/posts\/([0-9]+)/,
    embedUrl: 'https://www.facebook.com/plugins/post.php?href=https://www.facebook.com/$1',
  },
  {
    regex: /https:\/\/www\.dailymotion\.com\/video\/([^/]+)/,
    embedUrl: 'https://www.dailymotion.com/embed/video/$1',
  },
  {
    regex: /https:\/\/www\.flickr\.com\/photos\/[^/]+\/([^/]+)/,
    embedUrl: 'https://www.flickr.com/photos/$1/player/',
  },
  {
    regex: /https:\/\/www\.kickstarter\.com\/projects\/([^/]+\/[^/]+)/,
    embedUrl: 'https://www.kickstarter.com/projects/$1/widget/video.html',
  },
];

export function getEmbedUrl(url) {
  for (const { regex, embedUrl } of embedUrls) {
    if (regex.test(url)) {
      return url.replace(regex, embedUrl);
    }
  }
  return url;
}
